module.exports = __webpack_public_path__ + "static/media/arrow-down.96e756a9.svg";